import type { MouseEvent, ReactNode } from 'react';
import type { IconProps } from '../Icon/Icon.types';

export const ALERT_TYPE = {
  DEFAULT: 'default',
  DANGER: 'danger',
  DARK: 'dark',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
} as const;

export interface AlertProps {
  /**
   * Change the appearance of the alert
   */
  alertType?: typeof ALERT_TYPE[keyof typeof ALERT_TYPE];

  /**
   * Adds custom class names to alert
   */
  classNames?: string;

  /**
   * Adds icon to alert
   */
  hasIcon?: boolean;

  /**
   * Main title of alert
   */
  headingText?: ReactNode;

  /**
   * Icon to display in alert. `alertType` is used by default
   */
  icon?: IconProps;

  /**
   * Adds dismiss button to alert
   */
  isDismissible?: boolean;

  /**
   * Adds global alert styles
   */
  isGlobal?: boolean;

  /**
   * Message text or element for alert
   */
  messageText?: ReactNode;

  /**
   * Callback function for dismiss button
   */
  onCloseClick?: (e: MouseEvent<HTMLButtonElement>) => void;

  /**
   * Sets the data-testid attribute
   */
  testid?: string;
}
